import React, { useState, useEffect } from "react";
import firebase from 'firebase/compat/app';
import { Button, Container, Row, Alert } from 'react-bootstrap'
import './Output.css';
import { getAuth } from "firebase/auth";
import "firebase/database"


function Output(props) {

    const [alert, setAlert] = useState("")

    function saveToList() {

        setAlert("")

        const auth = getAuth();
        const user = auth.currentUser;
        const uid = user.uid;

        const newFavoriteRef = firebase
            .database()
            .ref(uid + "/favorites")

        const product = {
            barcode: props.foundProduct.barcode,
            code: props.foundProduct.code,
            productName: props.foundProduct.productName
        }

        if (newFavoriteRef.push(product)) {
            return setAlert("Product added to favorites.")
        }
    }

    useEffect(() => {
        setTimeout(() => {
            setAlert(false);
        }, 2000);
    }, [alert]);

    return (
        <div>
            <Container id="output">
                <Row>
                    <h4>Product</h4>
                    <div>
                        <Alert variant="secondary">
                            {props.foundProduct.code} - {props.foundProduct.productName}
                        </Alert>
                        {alert && <Alert variant="success">{alert}</Alert>}
                        <Button onClick={saveToList} variant="dark">Save to list</Button>
                    </div>
                </Row>
            </Container>
        </div>
    )
}

export default Output